// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".take-photo-skeleton[data-v-828370e0]{width:100vw;height:100vh;position:fixed;top:0;left:0;z-index:10000;background-color:#2c353b;padding:85px 20px 20px}[data-v-828370e0] .el-skeleton__rect{padding-bottom:165%;border-radius:0}", ""]);
// Exports
module.exports = exports;
